import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { IAcquisitionTypeDto } from '~/models/modules/Asset/acquisitionType';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class AcquisitionTypeService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }
  getAcquisitionTypeById(id:number){
    return this.client.get<IAcquisitionTypeDto>(this._url(`/${id}`))
  }
  getAcquisitionTypeListing(){
    return this.http.get<IAcquisitionTypeDto[]>(this._url());
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AcquisitionType${v}`);
  }
}
